import { render, staticRenderFns } from "./confirmationdialog.vue?vue&type=template&id=45500566&"
import script from "./confirmationdialog.vue?vue&type=script&lang=ts&"
export * from "./confirmationdialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45500566')) {
      api.createRecord('45500566', component.options)
    } else {
      api.reload('45500566', component.options)
    }
    module.hot.accept("./confirmationdialog.vue?vue&type=template&id=45500566&", function () {
      api.rerender('45500566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/confirmationdialog.vue"
export default component.exports